import React, { ComponentProps } from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { useWorkspace, WorkspaceConfig } from '../../graphql/hooks/useWorkspace';
import { Direction, ISalesOrderDeliveryAddress } from '../../graphql/schema/p4types';
import SalesOrderDeliveryAddress from '../../graphql/entities/sales/SalesOrderDeliveryAddress';

const { type, workspace, title, formUrl } = SalesOrderDeliveryAddress;

const SalesOrderDeliveryAddressWorkspace = (
  props: WorkspaceConfig<ISalesOrderDeliveryAddress> & ComponentProps<typeof Workspace>
) => {
  const workspaceProps = useWorkspace<ISalesOrderDeliveryAddress>(props, SalesOrderDeliveryAddress, {
    columns: [
      'deliveryName',
      'deliveryAddress.line1',
      'deliveryAddress.line2',
      'deliveryAddress.line3',
      'deliveryAddress.line4',
      'deliveryAddress.line5',
      'deliveryAddress.what3words',
    ],
    initialSortColumn: 'updatedAt',
    initialSortDirection: Direction.Desc,
  });
  return (
    <Workspace
      entityType={type}
      title={title}
      formUrl={formUrl}
      defaultQuery={workspace}
      entity={SalesOrderDeliveryAddress}
      {...workspaceProps}
      {...props}
    />
  );
};

export default SalesOrderDeliveryAddressWorkspace;
